import { useNavigate } from 'react-router-dom'
import { Button } from '../components/Button.js'
import { Card } from '../components/Card.js'
import { Pill } from '../components/Pill.js'
import { ProgressRing } from '../components/ProgressRing.js'
import type { Me } from '@my-eng/shared'
import styles from './Today.module.css'

/**
 * The home screen: one primary action, and never an empty page — if nothing is
 * due it offers new words or a duel (CLAUDE.md > Screens & navigation).
 *
 * The counts are zeros until the scheduler exists; the layout is what is being
 * built here, and it is wired to the real user from `/auth/me`.
 */
export function Today({ user }: { user: Me }) {
  const navigate = useNavigate()

  const doneToday = 0
  const goal = user.dailyGoalNew
  const dueNow = 0

  return (
    <div className={styles.screen}>
      <header className={styles.header}>
        <div>
          <p className={styles.greeting}>Привет, {user.displayName ?? 'друг'}</p>
          <p className={styles.sub}>
            {user.estimatedLevel
              ? `Твой уровень — ${user.estimatedLevel}`
              : 'Уровень ещё не определён'}
          </p>
        </div>
        <Pill tone="warning" icon={<span aria-hidden="true">🔥</span>}>
          0 дней
        </Pill>
      </header>

      <div className={styles.ringWrap}>
        <ProgressRing
          value={doneToday}
          target={goal}
          label={`${doneToday}/${goal}`}
          caption="новых слов сегодня"
        />
      </div>

      <div className={styles.actions}>
        <Button onClick={() => void navigate('/session')}>
          {dueNow > 0 ? `Заниматься — ${dueNow} на повторение` : 'Начать занятие'}
        </Button>
      </div>

      {!user.estimatedLevel && (
        <Card title="С чего начать">
          <p className={styles.cardText}>
            Пройди короткий тест на уровень — около трёх минут. Он нужен, чтобы первые слова были не
            слишком простыми и не безнадёжными.
          </p>
          <div className={styles.cardAction}>
            <Button variant="secondary" onClick={() => void navigate('/onboarding')}>
              Пройти тест
            </Button>
          </div>
        </Card>
      )}
    </div>
  )
}
